import $ from 'jquery';
window.$ = window.jQuery = $;
import { default as Common } from './modules/common.js';
import { default as Accordion } from './modules/accordion.js';
import { default as Animation } from './modules/animation.js';
import { default as Footer } from './modules/footer.js';
import { default as Login } from './modules/login.js';
import { default as Modal } from './modules/modal.js';
import { default as Nav } from './modules/nav.js';

const modules = {
  Common,
  Accordion,
  Animation,
  Footer,
  Login,
  Modal,
  Nav,
};

Object.keys(modules).forEach(key => {
  modules[key].init();
  window[key] = modules[key];
});
